import Footer from 'components/Header/Footer'
import Header from 'components/Header/Header'
import React from 'react'

import UkList from './UkList'
const UkUni = () => {
  return (
    <div className='main'>
        <Header/>
        <UkList/>
    <Footer/>
    </div>  )
}

export default UkUni